import axios from "axios";

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class ACLService {
  async roles(authToken) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.get(API_URL + `/ACL/Roles`, {
        headers,
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }
}

export default new ACLService();
